<template>
  <section>
    <div v-show="isValidToken && !isLoading" class="hero">
      <div class="hero-body is-full">
        <error-display-component :serverErrors="serverErrors" :serverErrorMessage="serverErrorMessage" id="error-container"></error-display-component>
        <service-vehicle-information :customer="customer" :serviceVideo="serviceVideoItem" :attachmentMediaIds="attachmentMediaIds" :vehicleInformation="vehicleName"></service-vehicle-information>
      </div>
    </div>
    <div v-show="!isValidToken && isLoading" class="hero">
      <div class="hero-body container">
        <div class="container is-fluid">
          <div class="columns is-vcentered loadingContainer">
            <div class="column is-12 has-text-centered has-text-weight-semi-bold">
              <img src="@/assets/ajax-loader.gif">
              <div v-if="loadingBaseData">Loading data....</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-show="!isValidToken && invalidTokenProvided" class="hero">
      <error-display-component :serverErrors="serverErrors" :serverErrorMessage="serverErrorMessage" id="token-error-container"></error-display-component>
    </div>
  </section>
</template>

<script>
import ServiceVehicleInformation from '@/components/generic/ServiceVehicleInformation'
import serviceVideoService from '@/services/serviceVideoService'
import ErrorDisplayComponent from '@/components/generic/ErrorDisplayComponent'
export default {
  components: {
    'service-vehicle-information': ServiceVehicleInformation,
    'error-display-component': ErrorDisplayComponent
  },
  data () {
    return {
      customer: null,
      serviceVideoItem: null,
      isLoading: false,
      isValidToken: false,
      serverErrors: [],
      serverErrorMessage: '',
      loadingBaseData: false,
      invalidTokenProvided: false,
      inventorySalesVideoId: 0,
      attachmentMediaIds: '',
      vehicleName: ''
    }
  },
  created () {
    this.$emit('is-home', false)
  },
  mounted () {
    this.$emit('set-title-one', 'VEHICLE')
    this.$emit('set-title-two', 'INFORMATION')
    const queryToken = this.$route.query.token
    if (this.token) {
      this.fetchCustomerVehicleInformation(this.token)
    } else if (queryToken) {
      this.fetchCustomerVehicleInformation(queryToken)
    } else {
      this.serverErrorMessage = 'Invalid or no authentication token provided'
      this.invalidTokenProvided = true
    }
  },
  watch: {
    token: function (newValue, oldValue) {
      this.isValidToken = false
      if (newValue) {
        this.fetchCustomerVehicleInformation(this.token)
      }
    }
  },
  methods: {
    fetchCustomerVehicleInformation: function (currentToken) {
      this.serverErrorMessage = ''
      this.loadingBaseData = true
      this.isLoading = true
      serviceVideoService.getCustomerServiceVideoInformation(currentToken).then(response => {
        this.customer = {
          ...response.customer
        }
        this.serviceVideoItem = {
          ...response.serviceVideo
        }
        this.$emit('set-title-one', this.serviceVideoItem.serviceWalkaroundType)
        const date = new Date(this.serviceVideoItem.createdAt)
        const dateString = `${date.toLocaleDateString()}`
        this.$emit('set-title-two', dateString)
        this.attachmentMediaIds = response.attachmentMediaIds
        this.vehicleName = response.vehicleName
        this.isValidToken = true
        this.isLoading = false
        this.loadingBaseData = false
      }).catch((error) => {
        this.isLoading = false
        this.loadingBaseData = false
        this.serverErrorMessage = 'Could not load vehicle information: ' + currentToken
        this.isValidToken = false
        console.log(error)
      })
    },
    resetValues () {
      this.customer = null
      this.inventoryItem = null
    }
  }
}
</script>
